import { Box } from '@mui/material';
import { Routes, Route } from 'react-router-dom';
import Main from './Main';
import LoginForm from './components/externalPages/LoginForm';
import UploadTranscript from './components/externalPages/UploadTranscript';
import TranscriptCalculator from './components/externalPages/TranscriptCalculator';
import CaptionCalculator from './components/externalPages/CaptionCalculator';
import UploadCaptions from './components/externalPages/UploadCaptions';
import UploadTranslation from './components/externalPages/UploadTranslation';
import TranslationCalculator from './components/externalPages/TranslationCalculator';
import TranscriptInfoPage from './components/externalPages/TranscriptInfoPage';
import CaptionInfoPage from './components/externalPages/CaptionInfoPage';
import TranslationInfoPage from './components/externalPages/TranslationInfoPage';
import TermsAndConditions from './components/externalPages/TermsAndConditions';

function App() {
  return (
    <Box sx={{ width: '100%', background: '#fff' }}>
      <Routes>
        <Route exact path="/" element={<Main />} />
        <Route path="/admin_login" element={<LoginForm />} />
        <Route path="/upload_transcript" element={<UploadTranscript />} />
        <Route path="/upload_captions" element={<UploadCaptions />} />
        <Route path="/upload_translation" element={<UploadTranslation />} />
        <Route path="/order_transcript" element={<TranscriptCalculator />} />
        <Route path="/order_captions" element={<CaptionCalculator />} />
        <Route path="/order_translation" element={<TranslationCalculator />} />
        <Route path="/proceed_with_transcription_order" element={<TranscriptInfoPage />} />
        <Route path="/proceed_with_caption_order" element={<CaptionInfoPage />} />
        <Route path="/proceed_with_translation_order" element={<TranslationInfoPage />} />
        <Route path="/terms_and_conditions" element={<TermsAndConditions />} />
      </Routes>
    </Box>
  );
}

export default App;
